const content = {
  title: "Applying Advanced Sentence Structures",
  explanation: `
This unit develops advanced sentence architecture, not only grammatical accuracy.
Example: Having reviewed the data, the committee approved the proposal.

Participle clauses and reduced relatives increase concision and information density.
Example: Students enrolled in the course must submit a portfolio.

Noun clauses and concessive structures support complex reasoning and balanced argumentation.
Example: What concerns analysts most is that growth remains uneven.

At C1, the goal is flexible syntactic choice based on clarity, emphasis, and style.
Example: Although the method is efficient, it raises ethical concerns.
  `,
  rules: [
    "Participle clauses are used to show time or cause",
    "Reduced relative clauses make sentences more concise",
    "Noun clauses can function as subjects or objects",
    "Concessive clauses express contrast"
  ],
  examples: [
    "Having finished the report, she sent it to her manager.",
    "The book lying on the table belongs to me.",
    "What he said shocked the audience.",
    "Despite being very tired, he continued working."
  ]
};

export default content;


